/* eslint-disable @angular-eslint/component-selector */
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  Output,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { Navigation } from './navigation-record.types';

@Component({
    selector: '[appNavigationRecord]',
    templateUrl: './navigation-record.component.html',
    imports: [
        RouterModule,
        CommonModule,
        MatDividerModule,
        MatMenuModule,
        MatIconModule,
    ]
})
export class NavigationRecordComponent {
  @Input({ required: true, alias: 'appNavigationRecord' })
  set navigationRecord(value: Navigation.Record) {
    this.record = value;
  }

  @Input({ required: true }) isMobile: boolean = false;

  @Output() navigationRecordAction = new EventEmitter<string>();

  private readonly record$ = signal<Navigation.Record>(undefined);

  private readonly router$ = inject(Router);

  onClick($event: MouseEvent): void {
    if ('pathname' in this.record && this.record.pathname) {
      if (this.record.pathname.startsWith('@')) {
        this.navigationRecordAction.emit(this.record.pathname.slice(1));
        $event.stopPropagation();
      }
    } else {
      $event.stopPropagation();
    }
  }

  get record(): Navigation.Record {
    return this.record$();
  }

  set record(value: Navigation.Record) {
    this.record$.set(value);
  }

  readonly activePathname = toSignal(
    this.router$.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.router$.url),
    ),
  );

  readonly isActive = computed(() =>
    this.isRecordActive(this.record$(), this.activePathname()),
  );

  private isRecordActive(record: Navigation.Record, pathname: string): boolean {
    if (record === undefined) return false;

    if ('pathname' in record && record.pathname) {
      return pathname.startsWith(record.pathname);
    }

    if ('children' in record) {
      return record.children.some((child) =>
        this.isRecordActive(child, pathname),
      );
    }

    return false;
  }
}
